import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ModalNewService from "../lservices/ModalNewService";
import "bootstrap/dist/css/bootstrap.min.css";
import API_URL from "../config";

const Tabsuiclients = () => {
  const [numtel, setPhone] = useState("");
  const [codeserv, setTypserv] = useState("C1");
  const [codemp, setCodemp] = useState("");
  const [ldate, setDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });
  const navigate = useNavigate();
  const [resultats, setResultats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Modal
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [data1, setData] = useState("");

  useEffect(() => {
    // Appel de la route backend
    fetch("/api/histdate")
      .then((res) => res.json())
      .then((data) => {
        // Vérifie que la date est bien au format YYYY-MM-DD
        setDate(data.histdate);
      })
      .catch((err) => console.error("Erreur API:", err));
  }, []);

  // Récupération des données
  const fetchHistory = async () => {
    setLoading(true);
    setError(null);
    setResultats([]);
    try {
      const formData = new FormData();
      formData.append("numtel", numtel);
      formData.append("ldate", ldate);
      formData.append("codeserv", codeserv);
      formData.append("codemp", codemp);

      const res = await axios.post(`${API_URL}/get_client_history/`, formData);
      setResultats(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setError("Impossible de charger l'historique");
    } finally {
      setLoading(false);
    }
  };

  // Auto-refresh uniquement si modal fermée
  useEffect(() => {
    if (openModal) return;
    const timer = setTimeout(() => fetchHistory(), 100);
    return () => clearTimeout(timer);
  }, [numtel, ldate, codeserv, codemp, openModal]);

  // Modal actions
  const handleActionClick = (action, codclt, nbre, lidsrv, lcodsrv) => {
    // k = codclt@@nomclient FORMAT EXACT comme ton composant NewService attend
    const selectedClient = resultats.find((x) => x.code === codclt);

    const k2 = `${codclt}@@${selectedClient.nom}@@${nbre}@@${action}@@${ldate}@@${lidsrv}@@${lcodsrv}`;
    setData(k2);
    setModalData(k2);
    setOpenModal(true);
  };

  const handleActionClick2 = (action) => {
    const parts = data1.split("@@");
    let k = "";
    if (action === "modify") {
      k = `${parts[0]}@@${parts[1]}@@${parts[2]}@@${action}@@${parts[4]}`;
    } else if (action === "payment") {
      k = `${parts[0]}@@${parts[1]}@@${parts[2]}@@${action}@@${parts[4]}@@${parts[5]}@@${parts[6]}`;
    } else if (action === "blacklist") {
      k = `${parts[0]}@@${parts[1]}@@${parts[2]}@@${action}@@${parts[4]}@@${parts[5]}@@${parts[6]}`;
    }

    setModalData(k);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setModalData(null);
    fetchHistory(); // 🔹 Rafraîchit le tableau après fermeture
  };

  return (
    <div style={styles.pageBackground}>
      <div style={styles.marqueeContainer}>
        <marquee behavior="scroll" direction="left" scrollamount="6">
          <span style={styles.marqueeText}>
            🌸 WELCOME TO NADINE'S HAIR BRAIDING &nbsp; | &nbsp; Tel: (202)
            706-2506 &nbsp; | &nbsp; Address: 4501 Mitchellville Road, Bowie, MD
            20716 🌸
          </span>
        </marquee>
      </div>

      <div className="container-fluid py-1">
        <div className="row justify-content-center">
          <div className="col-12 col-md-11 col-lg-12">
            <div style={styles.card}>
              <div className="text-center mb-1">
                <img
                  src={require("../../assets/images/logo_fenasu.png")}
                  alt="logo"
                  style={{ width: "180px" }}
                />
                <h2>CLIENT OPERATIONS TRACKING</h2>
              </div>

              {/* Filtres */}
              <form>
                <div className="row g-3 align-items-end mb-1">
                  <div className="col-12 col-sm-6 col-md-2">
                    <label className="form-label fw-bold fs-6">
                      Type of service
                    </label>
                    <select
                      value={codeserv}
                      onChange={(e) => setTypserv(e.target.value)}
                      className="form-select form-select-lg shadow-sm"
                      style={styles.inputField}
                    >
                      <option value="C1">C1 --- Check in</option>
                      <option value="C2">C2 --- In Service</option>
                      <option value="C3">C3 --- In Service + Review</option>
                      <option value="C4">C4 --- Review</option>
                    </select>
                  </div>

                  <div className="col-12 col-sm-6 col-md-2">
                    <label className="form-label fw-bold fs-6">Date</label>
                    <input
                      type="date"
                      className="form-control form-control-lg shadow-sm"
                      value={ldate}
                      onChange={(e) => setDate(e.target.value)}
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-12 col-sm-6 col-md-2">
                    <label className="form-label fw-bold fs-6">Téléphone</label>
                    <input
                      type="text"
                      className="form-control form-control-lg shadow-sm"
                      placeholder="Recherche"
                      value={numtel}
                      onChange={(e) => setPhone(e.target.value)}
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-12 col-sm-6 col-md-3">
                    <label className="form-label fw-bold fs-6">Braiders</label>
                    <input
                      type="text"
                      className="form-control form-control-lg shadow-sm"
                      placeholder="Recherche"
                      value={codemp}
                      onChange={(e) => setCodemp(e.target.value)}
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-12 col-sm-6 col-md-3 justify-content-center">
                    {/* Bouton Refresh */}
                    <button
                      type="button"
                      className="btn fw-bold shadow-sm"
                      style={styles.viewButton}
                      onClick={fetchHistory}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm "
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Chargement...
                        </>
                      ) : (
                        "🔍 Refresh"
                      )}
                    </button>

                    {/* Bouton Retour */}
                    <button
                      type="button"
                      className="btn fw-bold shadow-sm"
                      style={styles.backButton}
                      onClick={() => navigate(-1)}
                    >
                      ⬅ Back
                    </button>
                  </div>
                </div>
              </form>

              {/* Tableau stylé */}
              <div
                className="table-responsive"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {loading && (
                  <div className="text-center my-4">
                    <div
                      className="spinner-border text-primary"
                      style={{ width: "4rem", height: "4rem" }}
                      role="status"
                    ></div>
                    <p className="mt-3 fw-bold">Loading data...</p>
                  </div>
                )}

                {error && <div className="alert alert-danger">{error}</div>}

                {!loading && resultats.length > 0 && (
                  <table
                    className="table table-hover align-middle"
                    style={styles.table}
                  >
                    <thead style={styles.tableHead}>
                      <tr>
                        <th style={styles.th}>N°</th>
                        <th style={styles.th}>Code</th>
                        <th style={styles.th}>First and Last Names</th>
                        <th style={styles.th}>Téléphone</th>
                        {(codeserv === "C2" ||
                          codeserv === "C3" ||
                          codeserv === "C4") && (
                          <>
                            <th style={styles.th}>Coiffeuses</th>
                            <th style={styles.th}>Shop</th>
                          </>
                        )}
                        <th style={styles.th}>Date-Heure</th>
                        {codeserv === "C2" && (
                          <th style={styles.th}>Mt Service</th>
                        )}
                        {codeserv === "C4" && (
                          <th style={styles.th}>Mt Payé</th>
                        )}
                        <th style={styles.th}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultats.map((client, index) => {
                        const isBlacklisted = client.blacklist;
                        let actionLabel = "";
                        switch (client.statut) {
                          case 0:
                            actionLabel = "Check in";
                            break;
                          case 1:
                            actionLabel = "In service";
                            break;
                          case 3:
                            actionLabel = "Review";
                            break;
                          default:
                            actionLabel = "N/A";
                        }
                        let buttonStyle = {
                          width: "100%",
                          height: "32px",
                          color: "white",
                          border: "none",
                          borderRadius: "10px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "0.3s ease",
                          boxShadow: "0px 3px 6px rgba(0,0,0,0.15)",
                        };

                        // Couleurs selon statut
                        if (client.statut === 0) {
                          // CHECK IN
                          buttonStyle.background =
                            "linear-gradient(45deg, #1976d2, #0d47a1)"; // Bleu
                        } else if (client.statut === 1) {
                          // IN SERVICE
                          buttonStyle.background =
                            "linear-gradient(45deg, #ff9800, #e65100)"; // Orange
                        } else if (client.statut === 3) {
                          // REVIEW
                          buttonStyle.background =
                            "linear-gradient(45deg, #4caf50, #1b5e20)"; // Vert
                        } else {
                          // N/A
                          buttonStyle.background =
                            "linear-gradient(45deg, #9e9e9e, #616161)"; // Gris
                        }

                        return (
                          <tr
                            key={client.code}
                            style={{
                              backgroundColor: isBlacklisted
                                ? "#ffcccc"
                                : index % 2 === 0
                                  ? "#f9f9f9"
                                  : "#ffffff",
                              transition: "background 0.3s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#e3f2fd")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = isBlacklisted
                                ? "#ffcccc"
                                : index % 2 === 0
                                  ? "#f9f9f9"
                                  : "#ffffff")
                            }
                          >
                            <td>{index + 1}</td>
                            <td>{client.code}</td>
                            <td>{client.nom}</td>
                            <td>{client.telephone}</td>
                            {(codeserv === "C2" ||
                              codeserv === "C3" ||
                              codeserv === "C4") && (
                              <>
                                <td>{client.coiffeuses}</td>
                                <td>{client.shop}</td>
                              </>
                            )}
                            <td>{client.date_heure}</td>
                            {codeserv === "C2" && (
                              <td style={{ textAlign: "center" }}>
                                {client.montant_service !== undefined
                                  ? new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    }).format(client.montant_service)
                                  : ""}
                              </td>
                            )}
                            {codeserv === "C4" && (
                              <td style={{ textAlign: "center" }}>
                                {client.montant_paye !== undefined
                                  ? new Intl.NumberFormat("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                    }).format(client.montant_paye)
                                  : ""}
                              </td>
                            )}
                            <td>
                              <button
                                onClick={() =>
                                  handleActionClick(
                                    actionLabel,
                                    client.code,
                                    client.nbres,
                                    client.lidserv,
                                    client.lcodserv,
                                  )
                                }
                                style={buttonStyle}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(1.06)";
                                  e.currentTarget.style.boxShadow =
                                    "0px 5px 12px rgba(0,0,0,0.25)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                  e.currentTarget.style.boxShadow =
                                    "0px 3px 6px rgba(0,0,0,0.15)";
                                }}
                              >
                                {actionLabel}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}

                {!loading && resultats.length === 0 && (
                  <div
                    className="text-center fw-bold my-4"
                    style={{ color: "#555" }}
                  >
                    No results found
                  </div>
                )}
              </div>

              {/* Modal */}

              <ModalNewService
                show={openModal}
                onClose={closeModal}
                onAction={handleActionClick2}
                k={modalData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  backButton: {
    background: "linear-gradient(90deg, #ff512f 0%, #dd2476 100%)",
    color: "white",
    border: "none",
    fontSize: "1.1rem",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "120px",
    height: "45px",
  },
  pageBackground: {
    height: "100vh",
    minHeight: "100vh",
    overflowY: "auto",
    background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
    paddingBottom: "30px",
  },
  marqueeContainer: {
    background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
    padding: "12px 0",
    borderBottom: "3px solid #fff",
  },
  marqueeText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1.3rem",
    letterSpacing: "1px",
  },
  card: {
    background: "#fff",
    borderRadius: "15px",
    padding: "50px 30px",
    minHeight: "85vh",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  },
  inputField: {
    width: "100%",
    borderRadius: "12px",
    border: "1px solid #ced4da",
    background: "linear-gradient(145deg, #f8f9fa, #e9ecef)",
    fontWeight: "500",
    color: "#495057",
    padding: "0.5rem 0.75rem",
    transition: "all 0.3s",
  },
  viewButton: {
    background: "linear-gradient(90deg, #00c6ff 0%, #0072ff 100%)",
    color: "white",
    border: "none",
    fontSize: "1.1rem",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "160px",
    height: "45px",
  },
  table: {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    minWidth: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
  },
  tableHead: {
    background: "linear-gradient(90deg, #0072ff, #00c6ff)",
    color: "white",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  th: {
    padding: "12px",
    textAlign: "center",
    borderBottom: "2px solid rgba(255,255,255,0.3)",
  },
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw", // corrigé : prendre toute la largeur de l'écran
    height: "100vh", // toute la hauteur de l'écran
    background: "rgba(0,0,0,0.45)",
    backdropFilter: "blur(3px)",
    display: "flex",
    alignItems: "center", // centre verticalement
    justifyContent: "center", // centre horizontalement
    zIndex: 9999,
    padding: "20px", // espace autour sur petits écrans
    boxSizing: "border-box",
  },
  modal: {
    background: "white",
    width: "100%", // prend toute la largeur possible
    maxWidth: "900px", // largeur max sur grands écrans
    maxHeight: "90vh", // hauteur max pour éviter overflow
    padding: "30px",
    borderRadius: "15px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
    overflowY: "auto", // scroll si contenu dépasse
    animation: "zoomFadeIn 0.3s ease-in-out", // animation fade/zoom
    display: "flex",
    flexDirection: "column",
  },
  closeBtn: {
    marginTop: "20px",
    width: "50%",
    padding: "10px",
    border: "none",
    borderRadius: "10px",
    fontWeight: "600",
    background: "linear-gradient(45deg, #d50000, #9b0000)",
    color: "white",
    cursor: "pointer",
  },
};

// Exemple animation CSS (à mettre globalement ou via style jsx/global)
const globalStyles = `
@keyframes zoomFadeIn {
  0% { opacity: 0; transform: scale(0.95); }
  100% { opacity: 1; transform: scale(1); }
}
`;

export default Tabsuiclients;
